let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("daCl8"), load("jkoeR"), load("azlpK")]).then(() => parcelRequire('gZHbC'));